var React = require('react');

var PageHeader = React.createClass({
    render: function () {
        return <div className="page-header">
            {this.props.children}
        </div>;
    }
})
module.exports = PageHeader;



// WEBPACK FOOTER //
// ./app/components/Layout/PageHeader.js